(ns portal.agency-configuration-page.view
  (:require [common.widgets.page :as page]
            [portal.adserver-table.view :refer [adserver-data-grid]]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [defui $]]))

(defui agency-configuration-page []
  (uix/use-effect (fn []
                    (rf/dispatch [:page.agency-configuration/init]))
                  [])
  ($ page/page
     ($ page/page-header
        {:title "Adservers"})
     ($ page/content-padding {:sx #js {:overflow "hidden"}}
        ($ adserver-data-grid))))
